module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-10.410e1d6a.png";